<template>
  <div>
    <question :idx="3">
      <p class="title">1、收益性物业利用年限法求取建筑物折旧时，建筑物的寿命应为（）</p>
      <ul>
        <li class="error"><span style="display: none">A</span><Icon type="md-close-circle" color="#ff3300"/>决定是保留还是辞退当前的物业管理企业</li>
        <li><span>B</span>与租户有良好的沟通</li>
        <li class="zhengque"><span style="display: none">C</span><Icon type="md-checkmark-circle" color="#009900"/>令物业管理企业为业主和租户提供更好的服务</li>
        <li><span>D</span>及时收取租金</li>
      </ul>
      <Button  class="btn" @click="next">下一题</Button>
    </question>
  </div>
</template>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less" rel="stylesheet/less">
</style>
<script type="text/ecmascript-6">
  import question from '../template/question'
    export default {
        name: '',
        props: {},
        data() {
            return {};
        },
        methods: {
          next(){
            this.$router.push({
              path: '/que3'
            })
          }
        },
        created() {

        },
        components: {
          question
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/question/qus3.vue